export default "__VITE_ASSET__etH0Ii6r__"